import {
  GetCarrierDto,
  PatchCarrierDto,
  PostCarrierDto,
} from "mock-api/src/shared-v2-types";
import { getApiDetailsDecorator, getUpdatedPropertiesFilter } from "src/utils";
import { BaseCarrier } from "./base-carrier.model";
import { CarrierDetails } from "./carrier.model";

export type CarrierUpdateArgs =
  ClassProperties<CarrierCreate> | ClassProperties<CarrierUpdate>;

const api = getApiDetailsDecorator<PatchCarrierDto | PostCarrierDto>();

export abstract class BaseCarrierUpdate extends BaseCarrier {
  public constructor(args: ClassProperties<BaseCarrierUpdate>) {
    super(args);
    this.isActive = args.isActive;
    this.typeId = args.typeId;
    this.comments = args.comments;
    this.contactEmails = args.contactEmails;
  }

  @api({ key: "carrierTypeId" }) public readonly typeId: number;
  @api({ key: "active" }) public readonly isActive: boolean;
  @api() public readonly comments: string | null;
  @api({ key: "appointmentNotificationEmails" }) public readonly contactEmails:
    string | null;

  public serialize(): Partial<GetCarrierDto> {
    return {
      appointmentNotificationEmails: this.contactEmails,
      comments: this.comments,
      active: this.isActive,
      carrierTypeId: this.typeId,
      carrierKey: this.key,
      name: this.name,
    };
  }
}

export class CarrierUpdate extends BaseCarrierUpdate {
  public constructor({ base, ...args }: ClassProperties<CarrierUpdate>) {
    super(args);
    this.base = base;

    this.filterUpdatedProperties = getUpdatedPropertiesFilter(
      this,
      this.base,
      args,
    );
  }

  private readonly filterUpdatedProperties: FilterPartial<PatchCarrierDto>;
  public readonly base: CarrierDetails;

  public override serialize(): PatchCarrierDto {
    return this.filterUpdatedProperties({
      ...super.serialize(),
    });
  }
}

export class CarrierCreate extends BaseCarrierUpdate {
  public constructor(args: ClassProperties<CarrierCreate>) {
    super(args);
  }
  public readonly base = null;

  public override serialize(): PostCarrierDto {
    return {
      comments: this.comments,
      appointmentNotificationEmails: this.contactEmails,
      name: this.name,
      active: this.isActive,
      carrierKey: this.key,
      carrierTypeId: this.typeId,
    };
  }
}
